import React, { Component } from 'react';
import { ChromePicker } from 'react-color';
import { Grid, Button, Box, MenuItem, Slider } from '@material-ui/core';
import { TextValidator } from 'react-material-ui-form-validator';
import Toggle from '../Toggle';
import ImgUpload from '../ImgUpload';
import OpacityIcon from '@material-ui/icons/Opacity';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';

class Customization extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      state,
      handleChange,
      sliderChange,
      handleColorChange,
      handleTabChange,
      handlePrevious,
      colorPickerToggle,
      getLabel,
      successCallback,
      failureCallback,
    } = this.props;
    const { current_tab, values, fonts_colors_arr } = state;
    const { bg_opacity } = values;
    const login_fields_arr = ['company', 'title', 'phone_number'];
    let login_fields = (
      <Grid container spacing={1} className={classes.loginFieldsContainer}>
        {login_fields_arr.map((ele, i) => {
          return (
            <Grid item md={12} xs={12} key={i}>
              <Toggle
                name={ele}
                checked={state.toggle[ele]}
                label={getLabel(ele)}
                handleChange={handleChange}
              />
            </Grid>
          );
        })}
      </Grid>
    );

    let fonts_colors = (
      <Grid container spacing={2}>
        {fonts_colors_arr.map((obj, i) => {
          return (
            <Grid item md={4} xs={12} key={i}>
              {obj.dropdown ? (
                <div className={classes.fontContainer}>
                  <div className={classes.colorLabel}>{obj.label}</div>
                  <TextValidator
                    className={classes.fontField}
                    fullWidth
                    onChange={handleChange}
                    placeholder="Montserrat"
                    value={values[obj.type]}
                    select={obj.select}
                    SelectProps={{ native: false }}
                    margin="dense"
                    InputLabelProps={{
                      shrink: true,
                      style: { fontSize: 20, top: '-5px', fontWeight: 'bold' },
                    }}
                  >
                    <MenuItem value="">Montserrat</MenuItem>
                  </TextValidator>
                </div>
              ) : !(obj.type == 'away_team_color' && state.values.team2_id == null) ? (
                <div
                  className={classes.colorContainer}
                  onClick={() => {
                    colorPickerToggle(obj.popup, 'show');
                  }}
                >
                  {state[obj.popup] ? (
                    <div
                      className={classes.colorPickerContainer}
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    >
                      <ChromePicker
                        className={classes.colorPicker}
                        color={values[obj.type]}
                        onChange={color => handleColorChange(color, obj.type)}
                      />
                      <Button
                        className={classes.colorButton}
                        onClick={() => {
                          colorPickerToggle(obj.popup, 'hide');
                        }}
                      >
                        DONE
                      </Button>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className={classes.colorInformation}>
                    <div className={classes.colorLabel}>{obj.label}</div>
                    <div>{values[obj.type]}</div>
                  </div>
                  <Box
                    className={classes.colorBox}
                    style={{ backgroundColor: values[obj.type] }}
                  />
                </div>
              ) : <></>}
            </Grid>
          );
        })}
      </Grid>
    );

    const marks = [
      { value: 0, label: '0' },
      { value: 20, label: '20' },
      { value: 40, label: '40' },
      { value: 60, label: '60' },
      { value: 80, label: '80' },
      { value: 100, label: '100' },
    ];

    return (
      <>
        <div className={classes.fieldsContainer}>
          <div className={classes.tabsContainer}>
            <div
              className={
                current_tab == 'terms_conditions'
                  ? classes.tabHeaderSelected
                  : classes.tabHeader
              }
              onClick={() => handleTabChange('terms_conditions')}
            >
              Terms & Conditions
            </div>
            <div
              className={
                current_tab == 'general'
                  ? classes.tabHeaderSelected
                  : classes.tabHeader
              }
              onClick={() => handleTabChange('general')}
            >
              Side Panel
            </div>
            <div
              className={
                current_tab == 'profile_inputs'
                  ? classes.tabHeaderSelected
                  : classes.tabHeader
              }
              onClick={() => handleTabChange('profile_inputs')}
            >
              Profile Inputs
            </div>
            <div
              className={
                current_tab == 'fonts_colors'
                  ? classes.tabHeaderSelected
                  : classes.tabHeader
              }
              onClick={() => handleTabChange('fonts_colors')}
            >
              Fonts & Colors
            </div>
          </div>

          {current_tab == 'terms_conditions' ||
          current_tab == 'general' ||
          current_tab == 'profile_inputs' ? (
            <Grid container spacing={1}>
              {state[current_tab].map((obj, i) => {
                return (
                  <Grid
                    item
                    md={6}
                    xs={12}
                    className={
                      values.hide_left_panel &&
                      current_tab == 'general' &&
                      obj.name != 'hide_left_panel'
                        ? classes.disableToggle
                        : ''
                    }
                    key={i}
                  >
                    <Toggle
                      name={obj.name}
                      checked={values[obj.name]}
                      label={getLabel(obj.name)}
                      handleChange={handleChange}
                      state={state}
                    />

                    {obj.name == 'show_login_field' &&
                    values['show_login_field']
                      ? login_fields
                      : ''}

                    {obj.upload && values[obj.name] ? (
                      <ImgUpload
                        obj={obj}
                        state={state}
                        image={
                          obj.name == 'show_left_sidebar_bg_image'
                            ? values.left_sidebar_bg_image
                            : values.page_bg_image
                        }
                        successCallback={successCallback}
                        failureCallback={failureCallback}
                        bg_opacity={bg_opacity}
                      />
                    ) : (
                      ''
                    )}

                    {obj.upload && values[obj.name] && obj.name == "show_page_bg_image" ? (
                      <Grid className={classes.opacContainer}>
                        <OpacityIcon className={classes.opacIcon} />
                        <span className={classes.opacLabel}>
                          {`opacity (%)`}
                        </span>
                        <Slider
                          defaultValue={100}
                          step={1}
                          valueLabelDisplay="auto"
                          marks={marks}
                          value={bg_opacity}
                          name='bg_opacity'
                          onChange={sliderChange}
                        />
                      </Grid>
                    ) : (
                      ''
                    )}
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            ''
          )}
          {current_tab == 'fonts_colors' ? fonts_colors : ''}
        </div>
        <Grid container className={classes.buttonContainer} spacing={4}>
          <Button
            className={classes.previousButton}
            onClick={() => handlePrevious('customizations')}
            variant="contained"
            color="default"
          >
            Previous
          </Button>
          <Button
            className={classes.nextButton}
            onClick={this.props.handleSubmit}
            variant="contained"
            color="primary"
          >
            {this.props.submitButtonName}
          </Button>
        </Grid>
      </>
    );
  }
}

export default withStyles(useStyles)(Customization);